export enum DefaultSortType {
  LATEST = 'latest',
  OLDEST = 'oldest',
}

export enum OpenSaleSortType {
  ENDING_SOON = 'endingSoon',
  NEWLY_LISTED = 'newlyListed',
}

export enum OfferSelectType {
  ALL_OFFERS = 'allOffers',
  OPEN_OFFERS = 'openOffers',
  ENDED_OFFERS = 'endedOffers',
  ACCEPTED_OFFERS = 'acceptedOffers',
  REJECTED_OFFERS = 'rejectedOffers',
}

export enum SportSelectType {
  ALL_SPORTS = 'allSport',
  FOOTBALL = 'football',
  BASEBALL = 'baseball',
  NBA = 'nba',
}
